import { CardDesign } from '@/core/domain/configurations/models/configurations.model';
import { PurchasePersistenceModel } from '@/core/domain/purchase-persistence/models/PurchasePersistence.model';
import {
    AfterContentChecked,
    ChangeDetectorRef,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { BehaviorSubject, of, switchMap } from 'rxjs';
import { GtmPageView } from '@/core/domain/gtm/models/gtm-page-view.models';
import { SetDataLayerParamsUseCase } from '@/core/domain/gtm/usecases/setDataLayer.usecase';
import { Router } from '@angular/router';
import { GetPurchaseUseCase } from '@/core/domain/purchase-persistence/usecases/get-purchase-persistence.usecase';
import { GtmCheckOut } from '@/core/domain/gtm/models/gtm-check-out.models';
import { Store } from '@ngrx/store';
import { setProgressAction } from '@/data/current-progress/store/current-progress.actions';
import { CheckLoginUseCase } from '@/core/domain/auth/usecases/check-login.usecase';
import { selectAuthValue } from '@/data/auth/store/auth.selectors';

@Component({
    selector: 'vg-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class MessageComponent implements OnInit, AfterContentChecked {
    public cardDesign$ = new BehaviorSubject<CardDesign | null>(null);

    public purchasePersistence: PurchasePersistenceModel | null = null;

    public currentImage = '';
    public isUserLogged = false;

    public onSelectedCard(cardDesign: CardDesign): void {
        this.cardDesign$.next(cardDesign);
    }
    constructor(
        private readonly gtmDataLayer: SetDataLayerParamsUseCase,
        private readonly store: Store,
        private readonly router: Router,
        private readonly cdref: ChangeDetectorRef,
        private readonly getPurchasePersistence: GetPurchaseUseCase,
        private readonly authCheckLogin: CheckLoginUseCase,
    ) {
        this.store.dispatch(setProgressAction({ value: 'personalization' }));
        this.initPurchasePersistence();
    }
    ngAfterContentChecked(): void {
        this.cdref.detectChanges();
    }
    ngOnInit() {
        this.store.select(selectAuthValue).subscribe(() => {
            this.initCheckLogin();
        });
        this.gtmPageView();
    }

    private initCheckLogin() {
        this.authCheckLogin
            .execute()
            .pipe(
                switchMap((auth) => {
                    if (auth) {
                        this.isUserLogged = auth.isLogged;
                    }
                    return of(null);
                }),
            )
            .subscribe();
    }

    gtmPageView() {
        this.gtmDataLayer.execute<GtmPageView>({
            event: 'ev_pageview',
            page_path: this.router.url,
            page_title: 'message',
        });
        this.gtmDataLayer.execute<GtmCheckOut>({
            event: 'checkout',
            category: 'viva_gift',
            action: 'checkout',
            label: 'add_message',
            login: this.isUserLogged ? 'Yes' : 'No',
            checkout: { step: '4', step_name: 'add_message' },
        });
    }
    public initPurchasePersistence(): void {
        this.getPurchasePersistence
            .execute()
            .subscribe((purchasePersistence) => {
                this.purchasePersistence = purchasePersistence;
            });
    }
}
